var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery"},[_c('div',{staticClass:"images"},_vm._l((_vm.images),function(img){return _c('img',{directives:[{name:"img",rawName:"v-img:gallery",arg:"gallery"}],key:img,staticClass:"thumbnail",attrs:{"src":_vm.getPath(img),"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }